const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

export const createPlanningPokerRoom = async (deck) => {
  const response = await fetch(`${API_URL}/api/planning-poker-rooms`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ deck }),
  })
  if (!response.ok) throw new Error('Não foi possível criar a sala.')
  return response.json()
}

export const joinPlanningPokerRoom = async (id, name) => {
  const response = await fetch(`${API_URL}/api/planning-poker-rooms/${id}/join`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name }),
  })
  if (!response.ok) throw new Error('Não foi possível entrar na sala.')
  return response.json()
}

export const fetchPlanningPokerState = async (id) => {
  const response = await fetch(`${API_URL}/api/planning-poker-rooms/${id}/state`)
  if (!response.ok) throw new Error('Sala não encontrada.')
  return response.json()
}

export const castPlanningPokerVote = async (id, participantId, vote) => {
  const response = await fetch(`${API_URL}/api/planning-poker-rooms/${id}/vote`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ participantId, vote }),
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível votar.')
  return data
}

export const revealPlanningPokerVotes = async (id, masterToken) => {
  const response = await fetch(`${API_URL}/api/planning-poker-rooms/${id}/reveal`, {
    method: 'POST',
    headers: { 'x-master-token': masterToken },
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível revelar os votos.')
  return data
}

// Pass `topic` to set the next round's topic; omit to keep the current one.
export const resetPlanningPokerRound = async (id, masterToken, topic) => {
  const response = await fetch(`${API_URL}/api/planning-poker-rooms/${id}/reset`, {
    method: 'POST',
    headers: { 'x-master-token': masterToken, 'Content-Type': 'application/json' },
    body: JSON.stringify(topic === undefined ? {} : { topic }),
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível iniciar a nova rodada.')
  return data
}

export const removePlanningPokerParticipant = async (id, masterToken, participantId) => {
  const response = await fetch(`${API_URL}/api/planning-poker-rooms/${id}/participants/${participantId}`, {
    method: 'DELETE',
    headers: { 'x-master-token': masterToken },
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível excluir o participante.')
  return data
}

export const planningPokerStreamUrl = (id) => `${API_URL}/api/planning-poker-rooms/${id}/stream`

export const planningPokerJoinUrl = (id) => `${window.location.origin}/ferramentas/planning-poker/${id}`
